import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie-consent', 'all');
    setShowBanner(false);
  };

  const acceptEssential = () => {
    localStorage.setItem('cookie-consent', 'essential');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-6 bg-dark-lighter/95 backdrop-blur-lg border-t border-white/10 shadow-2xl">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between gap-8 flex-wrap">
          <div className="flex-1 min-w-[300px]">
            <h3 className="text-white font-semibold text-lg mb-2">
              🍪 Cookie-Einstellungen
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Wir verwenden Cookies, um Ihnen die bestmögliche Nutzererfahrung zu bieten. Einige Cookies sind technisch notwendig, andere helfen uns, unsere Website zu verbessern. Sie können Ihre Einstellungen jederzeit anpassen.
              <a href="/datenschutz" className="text-primary hover:text-primary-light transition-colors ml-1 cursor-pointer">
                Mehr erfahren
              </a>
            </p>
          </div>
          
          <div className="flex items-center gap-4 flex-wrap">
            <button
              onClick={acceptEssential}
              className="px-6 py-3 bg-white/10 text-white rounded-lg font-medium hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Nur notwendige
            </button>
            <button
              onClick={acceptAll}
              className="px-6 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary-light transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Alle akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
